import { GuideExperienceRange } from '@/types';

/** Dropdown order on the application form, shortest to longest. */
export const GUIDE_EXPERIENCE_OPTIONS: { value: GuideExperienceRange; label: string }[] = [
  { value: GuideExperienceRange.NONE, label: 'No experience' },
  { value: GuideExperienceRange.ONE_TO_FIVE, label: '1-5 years' },
  { value: GuideExperienceRange.FIVE_TO_TEN, label: '5-10 years' },
  { value: GuideExperienceRange.TEN_TO_FIFTEEN, label: '10-15 years' },
  { value: GuideExperienceRange.FIFTEEN_TO_TWENTY, label: '15-20 years' },
  { value: GuideExperienceRange.TWENTY_PLUS, label: 'More than 20 years' },
];

export const GUIDE_EXPERIENCE_LABEL = Object.fromEntries(
  GUIDE_EXPERIENCE_OPTIONS.map(({ value, label }) => [value, label])
) as Record<GuideExperienceRange, string>;
